<template>
  <div class="container">
    <ul v-if="subDetail != ''">
      <li>
        <label>项目：</label>
        <p>{{ subDetail.project_name }}</p>
      </li>
      <li>
        <label>入库日期：</label>
        <p>{{ subDetail.in_date }}</p>
      </li>
      <li>
        <label>批次编号：</label>
        <p>{{ subDetail.no }}</p>
      </li>
      <li>
        <label>操作人：</label>
        <p>{{ subDetail.user_name }}</p>
      </li>
    </ul>
    <table>
      <thead>
        <th>商品名称</th>
        <th>商品图</th>
        <th>入库数量</th>
      </thead>
      <tbody>
        <tr v-for="(item, index) in detail" :key="index">
          <td>{{ item.brand_name }}</td>
          <td>
            <img :src="item.imageUrl.url_thumb" alt="" />
          </td>
          <td>{{ item.num }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      detail: "",
      subDetail: ""
    };
  },
  props: {
    detailVal: {}
  },
  watch: {
    detailVal() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.detailVal != undefined) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.subDetail = this.detailVal;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_in/getProjectInDetail";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        project_in_id: this.detailVal.id
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.detail = res.data.data;
          console.log(this.detail);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  padding: 30px 4%;
  table {
    td,
    th {
      border: 1px solid #ccc;
      padding: 4px 6px;
    }
    tr {
      img {
        height: 30px;
        width: 30px;
      }
    }
  }
  ul {
    li {
      margin-bottom: 10px;
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
</style>
